import script from "./CampaignDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignDetail.vue?vue&type=script&setup=true&lang=js"

import "./CampaignDetail.vue?vue&type=style&index=0&id=962fb6b2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-962fb6b2"]])

export default __exports__